/*
 * Module for the topic label list and touchPoint Label list.
 */

define(["marionette", "jquery", "messaging/messenger", "./touchPointLabelListView"], function (
  Marionette,
  $,
  Messenger,
  TouchPointLabelListView,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "touchPointLabelList";
      this.hideHeader = options.hideHeader;
      this.namespace = options.namespace; //namespace used by the sortable list
    },
    show: function (topicLabels, touchPointLabels) {
      touchPointLabels.onSynced(function () {
        this.topicLabels = topicLabels;
        this.touchPointLabels = touchPointLabels;
        this._buildView();
        this.showRegion(this.view);
      }, this);
    },

    _buildView: function () {
      this.view = new TouchPointLabelListView.touchPointLabelsView({
        collection: this.touchPointLabels,
        topicLabels: this.topicLabels,
      });

      this.view.on("change:touchpoint:label", () => {
        this.view.render();
      });
    },
  });
});
